/**
 * Shared theme-color reader for Elo/rating charts (light/dark aware via CSS variables).
 * Used by EloHistoryChart and SessionEloTrendChart so both charts stay visually consistent.
 */
export function getChartThemeColors() {
  if (typeof document === 'undefined') {
    return {
      text: '#64748b',
      textMuted: '#94a3b8',
      surface: '#ffffff',
      border: '#cbd5e1',
      grid: '#e2e8f0',
      mixed: '#D946EF',
      levels: '#3D63AE',
      win: '#22c55e',
      loss: '#ef4444',
    };
  }
  const root = document.documentElement;
  const get = (v) => getComputedStyle(root).getPropertyValue(v).trim();
  return {
    text: get('--color-text-secondary') || get('--color-text-primary') || '#64748b',
    textMuted: get('--color-text-muted') || '#94a3b8',
    surface: get('--color-surface') || '#ffffff',
    border: get('--color-border-medium') || '#cbd5e1',
    grid: get('--color-border-light') || '#e2e8f0',
    mixed: get('--color-female') || '#D946EF',
    levels: get('--color-primary') || '#3D63AE',
    win: get('--color-success') || '#22c55e',
    loss: get('--color-danger') || '#ef4444',
  };
}
